import { Box, IconButton } from '@material-ui/core';
import { MerchantStructure, User } from '@nemuru-eng/js-api-client';

import { StructureCardWrapper } from '@/components/modules/MerchantDetail/MerchantStructure/components/StructureCard/StructureCardWrapper';
import { StyledTooltip } from '@/components/shared/components/StyledTooltip';
import { useStructureUser } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangeUser/hooks/useStructureUser';
import { Font } from '@/components/shared/components/Font';
import { SizedIconWithCircle } from '@/components/shared/components/SizedIconWithCircle';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { UserInStructure } from '@/types/UserInStructure';

interface UserInStructureCardProps {
  user: User | UserInStructure;
  merchantStructure: MerchantStructure;
  type: 'channel' | 'merchant' | 'agent';
  id: string;
  isSelected: boolean;
  iconName: string;
  onClick?: () => void;
}

export const UserInStructureCard = ({
  user,
  merchantStructure,
  type,
  id,
  isSelected,
  onClick,
  iconName,
}: UserInStructureCardProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const { selectedUserMerchant, selectedUserChannel, selectedUserAgent } = useStructureUser({
    selectedUser: user,
    merchantStructure,
  });

  const userPath = `${selectedUserMerchant}${selectedUserChannel ? ` > ${selectedUserChannel.description}` : ''}${
    selectedUserAgent ? ` > ${selectedUserAgent.name}` : ''
  }`;

  return (
    <StructureCardWrapper type={type} id={id} isSelected={isSelected} onClick={onClick}>
      <IconButton
        onClick={onClick}
        style={{
          padding: '0',
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'flex-start',
          borderRadius: customBorderRadius.paper,
          marginBlock: '-6px',
          paddingBlock: '6px',
        }}
      >
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'} pr={1} overflow={'hidden'}>
          <Box position={'relative'}>
            <SizedIconWithCircle
              variant={'medium'}
              backgroundColor={'transparent'}
              iconColor={isSelected ? palette.secondary.contrastText : palette.secondary.main}
              customBorderRadius={0}
              iconName={iconName}
            />
          </Box>
          <StyledTooltip title={<Font variant="caption">{userPath}</Font>} tooltipProps={{ placement: 'top' }}>
            <Box
              pl={1}
              pr={3}
              height={34}
              className="overflow-text-ellipsis"
              color={isSelected ? palette.secondary.contrastText : palette.secondary.main}
            >
              <Font variant="body2">
                <strong>{userPath}</strong>
              </Font>
            </Box>
          </StyledTooltip>
        </Box>
      </IconButton>
    </StructureCardWrapper>
  );
};
